export const APP_PAGES = [
  {
    title: 'app.pages.menu.home',
    url: '/posts-list',
    direct: 'root',
    icon: 'home'
  },
  {
    title: 'app.pages.menu.contracts',
    url: '/contracts',
    direct: 'forward',
    icon: 'paper'
  }, 
  {
    title: 'app.pages.menu.booking',
    url: '/booking',
    direct: 'forward',
    icon: 'book'
  }, 
  /* {
    title: 'Favorites',
    url: '/favorites',
    direct: 'forward',
    icon: 'heart'
  }, */
  /* {
    title: 'Rent a Car',
    url: '/rentcar',
    direct: 'forward',
    icon: 'car'
  }, */
  /* {
    title: 'Trip Activities',
    url: '/activities',
    direct: 'forward',
    icon: 'beer'
  }, */
  /* {
    title: 'Local Weather',
    url: '/local-weather',
    direct: 'forward',
    icon: 'partly-sunny'
  }, */
  {
    title: 'app.pages.menu.card',
    url: '/card',
    direct: 'forward',
    icon: 'card'
  },  
  {
    title: 'app.pages.menu.restaurants',
    url: '/restaurants',
    direct: 'forward',
    icon: 'restaurant'
  },
  {
    title: 'app.pages.menu.rules',
    url: '/rules',
    direct: 'forward',
    icon: 'warning'
  },
  {
    title: 'app.pages.menu.faq',
    url: '/faq',
    direct: 'forward',
    icon: 'help-circle-outline'
  },
  {
    title: 'app.pages.menu.support',
    url: '/support',
    direct: 'forward',
    icon: 'help-buoy'
  },
  {
    title: 'app.pages.menu.about',
    url: '/about',
    direct: 'forward',
    icon: 'information-circle-outline'
  },
];
